/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var Badge_1 = require("./Badge");
var Icon_1 = require("./Icon");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./SidebarNavigation.css'); }
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-sidebarNavigation");
exports.SidebarNavigation = function SidebarNavigation(_a) {
    var children = _a.children, fullWidth = _a.fullWidth, className = _a.className;
    return (React.createElement("nav", { className: classnames(moduleClassName(), fullWidth && moduleClassName("isFullWidth"), className) }, React.Children.map(children, function (child) {
        return !child
            ? null
            : React.cloneElement(child, {
                chevron: fullWidth,
                badgeSize: fullWidth ? "large" : "medium"
            });
    })));
};
exports.SidebarNavigation.propTypes = {
    className: PropTypes.string,
    fullWidth: PropTypes.bool
};
exports.SidebarNavigationTitle = function SidebarNavigationTitle(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames(moduleClassName("title"), className) }, children));
};
exports.SidebarNavigationTitle.propTypes = {
    className: PropTypes.string
};
exports.SidebarNavigationLink = function SidebarNavigationLink(_a) {
    var _b = _a.TagName, TagName = _b === void 0 ? "a" : _b, active = _a.active, className = _a.className, iconType = _a.iconType, children = _a.children, badgeCount = _a.badgeCount, chevron = _a.chevron, badgeSize = _a.badgeSize, props = tslib_1.__rest(_a, ["TagName", "active", "className", "iconType", "children", "badgeCount", "chevron", "badgeSize"]);
    var tagProps = tslib_1.__assign({}, props, { className: classnames(moduleClassName("link"), !!iconType && moduleClassName("link-hasIcon"), active && moduleClassName("isActive"), className) });
    return (React.createElement(TagName, tslib_1.__assign({}, tagProps),
        !!iconType && (React.createElement(Icon_1.Icon, { className: moduleClassName("icon"), size: chevron ? 1 : 0.8, type: iconType })),
        children,
        !!badgeCount && (React.createElement(Badge_1.Badge, { count: badgeCount, size: badgeSize, className: moduleClassName("badge") })),
        !!chevron && (React.createElement(Icon_1.Icon, { className: moduleClassName("chevron"), size: 1.2, type: "chevron-right", color: "grey-tint-60" }))));
};
exports.SidebarNavigationLink.propTypes = {
    className: PropTypes.string,
    TagName: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.func,
        PropTypes.string
    ]),
    active: PropTypes.bool,
    iconType: PropTypes.oneOf(Icon_1.IconTypesArray),
    badgeCount: PropTypes.number,
    chevron: PropTypes.bool
};